module.exports = __webpack_public_path__ + "img/banner-f3ef9689.png";